import { useEffect, useRef, useState } from "react";
import { Share2, Twitter, Linkedin, Download } from "lucide-react";
import { toast } from "sonner";

export function ShareDropdown({ text, title }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const tweet = () => {
    window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(text.substring(0, 240) + "\n\n— Made with CopyForge AI")}`, "_blank");
    setOpen(false);
  };
  const linkedin = () => {
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(window.location.origin)}`, "_blank");
    setOpen(false);
  };
  const download = () => {
    const blob = new Blob([text], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${title || "copyforge"}.txt`;
    a.click();
    URL.revokeObjectURL(url);
    toast.success("Downloaded");
    setOpen(false);
  };

  return (
    <div className="relative" ref={ref}>
      <button onClick={() => setOpen(!open)} className="flex items-center gap-1.5 text-sm text-zinc-500 hover:text-zinc-900" data-testid="share-btn">
        <Share2 className="w-3.5 h-3.5" /> Share
      </button>
      {open && (
        <div className="absolute right-0 top-8 bg-white border border-zinc-200 shadow-lg z-50 w-48 py-1 animate-fade-in" data-testid="share-dropdown">
          <button onClick={tweet} className="w-full flex items-center gap-2.5 px-3 py-2 text-sm text-zinc-700 hover:bg-zinc-50" data-testid="share-twitter"><Twitter className="w-4 h-4" /> Twitter</button>
          <button onClick={linkedin} className="w-full flex items-center gap-2.5 px-3 py-2 text-sm text-zinc-700 hover:bg-zinc-50" data-testid="share-linkedin"><Linkedin className="w-4 h-4" /> LinkedIn</button>
          <div className="border-t border-zinc-100 my-1" />
          <button onClick={download} className="w-full flex items-center gap-2.5 px-3 py-2 text-sm text-zinc-700 hover:bg-zinc-50" data-testid="download-txt"><Download className="w-4 h-4" /> Download .txt</button>
        </div>
      )}
    </div>
  );
}
